/** Site-wide marketing facts and links (single source for landing, footer, apps page). */

export const APP_STORE_URL =
  'https://apps.apple.com/app/apple-store/id1661113382?pt=118234495&ct=website_footer&mt=8';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.napprmobile&utm_source=website&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';

export const SUPPORT_EMAIL = 'info@nappr.io';

export const STATS = [
  { value: '6,100+', label: 'hotels' },
  { value: '41', label: 'countries & territories' },
  { value: '60', label: 'airports' },
  { value: 'Up to 75%', label: 'off nightly rates' },
];

export const COUNTRIES = [
  { name: 'Andorra', code: 'ad' },
  { name: 'Argentina', code: 'ar' },
  { name: 'Australia', code: 'au' },
  { name: 'Belgium', code: 'be' },
  { name: 'Brazil', code: 'br' },
  { name: 'Canada', code: 'ca' },
  { name: 'Chile', code: 'cl' },
  { name: 'Colombia', code: 'co' },
  { name: 'Czech Republic', code: 'cz' },
  { name: 'Denmark', code: 'dk' },
  { name: 'Ecuador', code: 'ec' },
  { name: 'France', code: 'fr' },
  { name: 'Germany', code: 'de' },
  { name: 'Greece', code: 'gr' },
  { name: 'India', code: 'in' },
  { name: 'Indonesia', code: 'id' },
  { name: 'Ireland', code: 'ie' },
  { name: 'Israel', code: 'il' },
  { name: 'Italy', code: 'it' },
  { name: 'Jamaica', code: 'jm' },
  { name: 'Kenya', code: 'ke' },
  { name: 'Malaysia', code: 'my' },
  { name: 'Mexico', code: 'mx' },
  { name: 'Netherlands', code: 'nl' },
  { name: 'Oman', code: 'om' },
  { name: 'Pakistan', code: 'pk' },
  { name: 'Panama', code: 'pa' },
  { name: 'Peru', code: 'pe' },
  { name: 'Philippines', code: 'ph' },
  { name: 'Poland', code: 'pl' },
  { name: 'Puerto Rico', code: 'pr' },
  { name: 'Qatar', code: 'qa' },
  { name: 'South Africa', code: 'za' },
  { name: 'Spain', code: 'es' },
  { name: 'St. Maarten', code: 'sx' },
  { name: 'Tanzania', code: 'tz' },
  { name: 'Thailand', code: 'th' },
  { name: 'Turkey', code: 'tr' },
  { name: 'United Arab Emirates', code: 'ae' },
  { name: 'United Kingdom', code: 'gb' },
  { name: 'United States', code: 'us' },
];
